export default function ChartMetadata({ metadata, input, debug }) {
  if (!metadata) return null;

  // Handle both date-based (simplified) and jiazi-based (full) metadata
  const isDateBased = metadata.source === "typingastro_mirror";

  return (
    <div className="chart-metadata" data-testid="chart-metadata">
      <div className="meta-row">
        {input && (
          <div className="meta-item">
            <span className="meta-label">Date</span>
            <span className="meta-value">
              {input.year}/{String(input.month).padStart(2, "0")}/{String(input.day).padStart(2, "0")} {String(input.hour).padStart(2, "0")}:{String(input.minute).padStart(2, "0")}
            </span>
          </div>
        )}
        {input?.system && (
          <div className="meta-item">
            <span className="meta-label">System</span>
            <span className="meta-value">{input.system_cn} {input.system}</span>
          </div>
        )}
        {metadata.type && (
          <div className="meta-item">
            <span className="meta-label">Type</span>
            <span className="meta-value">{metadata.type_cn} {metadata.type}</span>
          </div>
        )}
        {metadata.dun_type && (
          <div className="meta-item">
            <span className="meta-label">Dun</span>
            <span className="meta-value meta-highlight">
              {metadata.dun_type} ({metadata.dun_type_en})
            </span>
          </div>
        )}
        {metadata.ju && (
          <div className="meta-item">
            <span className="meta-label">Ju</span>
            <span className="meta-value meta-ju">{metadata.ju}</span>
          </div>
        )}
        {metadata.yuan && (
          <div className="meta-item">
            <span className="meta-label">Yuan</span>
            <span className="meta-value">
              {metadata.yuan.chinese} ({metadata.yuan.english})
            </span>
          </div>
        )}
        {metadata.solar_term && (
          <div className="meta-item">
            <span className="meta-label">Solar Term</span>
            <span className="meta-value">
              {metadata.solar_term.chinese} ({metadata.solar_term.english})
            </span>
          </div>
        )}
        {metadata.hour_jiazi && (
          <div className="meta-item">
            <span className="meta-label">Hour JiaZi</span>
            <span className="meta-value">{metadata.hour_jiazi}</span>
          </div>
        )}
        {metadata.day_jiazi && (
          <div className="meta-item">
            <span className="meta-label">Day JiaZi</span>
            <span className="meta-value">{metadata.day_jiazi}</span>
          </div>
        )}
        {metadata.lookup_key && (
          <div className="meta-item">
            <span className="meta-label">Lookup Key</span>
            <span className="meta-value meta-key">{metadata.lookup_key}</span>
          </div>
        )}
        {isDateBased && (
          <div className="meta-item">
            <span className="meta-label">Source</span>
            <span className="meta-value meta-source">typingastro mirror</span>
          </div>
        )}
      </div>
      
      {/* Debug Panel - Part 10 Validation Mode */}
      {debug && debug.lookup_key && (
        <div className="debug-panel" data-testid="debug-panel">
          <h4>Debug Mode - Validation Info</h4>
          <div className="debug-info">
            <strong>Input DateTime:</strong> {input?.year}-{String(input?.month).padStart(2, "0")}-{String(input?.day).padStart(2, "0")} {String(input?.hour).padStart(2, "0")}:{String(input?.minute).padStart(2, "0")}
          </div>
          {metadata.hour_jiazi && (
            <div className="debug-info">
              <strong>Hour JiaZi:</strong> {metadata.hour_jiazi}
            </div>
          )}
          {metadata.dun_type && (
            <div className="debug-info">
              <strong>Dun Type:</strong> {metadata.dun_type} ({metadata.dun_type_en})
            </div>
          )}
          {metadata.ju && (
            <div className="debug-info">
              <strong>Ju:</strong> {metadata.ju}
            </div>
          )}
          <div className="debug-info">
            <strong>Lookup Key:</strong> <code>{debug.lookup_key}</code>
          </div>
          <div className="debug-info">
            <strong>Source:</strong> qimen_1080_master.json
          </div>
          {debug.source_info && (
            <div className="debug-info">
              <strong>Source Info:</strong> {JSON.stringify(debug.source_info)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
